const sameValue = (a: unknown, b: unknown): boolean => JSON.stringify(a) === JSON.stringify(b);

/**
 * The fields of `current` that differ from `loaded`, for a PATCH that writes only what the user
 * changed. Arrays and objects compare as a whole. `id` is left out (it addresses the request), and
 * so is an undefined value (JSON cannot carry it).
 *
 * The CRM applies the invoicing level itself (house_level clears the project value and deletes the
 * termijnen, project_level clears the price per house), so the amounts the chosen level discards
 * are not sent.
 */
export function changedProjectFields<T extends object>(loaded: T, current: T): Partial<T> {
    const before = loaded as Record<string, unknown>;
    const after = current as Record<string, unknown>;
    const changes: Record<string, unknown> = {};

    Object.keys(after).forEach(key => {
        if (key === "id" || after[key] === undefined) return;

        if (!sameValue(before[key], after[key])) {
            changes[key] = after[key];
        }
    });

    if (after.invoicingMethod === "house_level") {
        delete changes.projectValue;
        delete changes.partialInvoicingDates;
    }

    if (after.invoicingMethod === "project_level") {
        delete changes.expectedPricePerHouse;
    }

    return changes as Partial<T>;
}
